import { createContext, useContext, type ReactNode } from "react";

/**
 * The slot in the `<booking-form>` widget's top bar, alongside the
 * expand/shrink control. Stage controls that belong on that line — the journey's
 * back control — render into it, so they are positioned against the widget's own
 * edges rather than the stage's. Provided only inside the widget; components
 * outside it read `null` and render in place.
 */
const WidgetTopBarContext = createContext<HTMLElement | null>(null);

export function useWidgetTopBar(): HTMLElement | null {
  return useContext(WidgetTopBarContext);
}

interface WidgetTopBarProviderProps {
  readonly slot: HTMLElement | null;
  readonly children: ReactNode;
}

export function WidgetTopBarProvider({ slot, children }: WidgetTopBarProviderProps): React.ReactElement {
  return <WidgetTopBarContext.Provider value={slot}>{children}</WidgetTopBarContext.Provider>;
}
